import styled, { css } from 'styled-components';

export const PageTitle = styled.h2`
  font-size: ${({ theme }) => theme.fs.lg};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  font-weight: bold;
`;

export const Title = styled.span<{ $size: string; $bold: boolean }>`
  ${({ $bold }) =>
    $bold
      ? css`
          font-weight: bold;
        `
      : css`
          font-weight: normal;
        `};

  ${({ $size }) =>
    $size === 'small'
      ? css`
          font-size: ${({ theme }) => theme.fs.xs};
        `
      : $size === 'normal'
      ? css`
          font-size: ${({ theme }) => theme.fs.sm};
        `
      : $size === 'medium'
      ? css`
          font-size: ${({ theme }) => theme.fs.md};
        `
      : $size === 'large'
      ? css`
          font-size: ${({ theme }) => theme.fs.lg};
        `
      : $size === 'x-large'
      ? css`
          font-size: ${({ theme }) => theme.fs.xl};
        `
      : ''};
`;

export const Text = styled.span<{ $size: string; $bold: boolean; $letterSpace: boolean; $textColor }>`
  ${({ $letterSpace }) =>
    $letterSpace
      ? css`
          letter-spacing: 1px;
        `
      : ``};
  ${({ $bold }) =>
    $bold
      ? css`
          font-weight: bold;
        `
      : css`
          font-weight: normal;
        `};
  ${({ $textColor }) =>
    $textColor === 'success'
      ? css`
          color: ${({ theme }) => theme.palette.success};
        `
      : $textColor === 'error'
      ? css`
          color: ${({ theme }) => theme.palette.error};
        `
      : $textColor === 'info'
      ? css`
          color: ${({ theme }) => theme.palette.secondary};
        `
      : $textColor === 'white'
      ? css`
          color: ${({ theme }) => theme.palette.white};
        `
      : css`
          color: ${({ theme }) => theme.palette.primary};
        `};
  ${({ $size }) =>
    $size === 'x-small'
      ? css`
          font-size: ${({ theme }) => theme.fs.xxs};
        `
      : $size === 'small'
      ? css`
          font-size: ${({ theme }) => theme.fs.xs};
        `
      : $size === 'normal'
      ? css`
          font-size: ${({ theme }) => theme.fs.sm};
        `
      : $size === 'x-large'
      ? css`
          font-size: ${({ theme }) => theme.fs.xl};
        `
      : $size === 'medium'
      ? css`
          font-size: ${({ theme }) => theme.fs.md};
        `
      : ''};
`;
